import '../themeDefaults';

export default ({ datepickerReact }) => ({
  dark: {},
  inputIcon: {
    '& svg': {
      fill: datepickerReact.inputIconButtonColor,
    },
    '&$dark': {
      '& svg': {
        fill: datepickerReact.dark.inputIconButtonColor,
      },
    },
    position: 'absolute',
    right: 9,
    top: 10,
  },
  inputWrapper: {
    ...datepickerReact.inputWrapper,
    '& input': {
      background: datepickerReact.input.backgroundColor,
      boxSizing: 'border-box',
      color: datepickerReact.input.color,
      ...datepickerReact.textInput,
    },
    '&$dark': {
      '& input': {
        background: datepickerReact.input.dark.backgroundColor,
        color: datepickerReact.input.dark.color,
      },
    },
  },
  toggle: {
    '&:focus': {
      outlineColor: datepickerReact.focusColor,
    },
    background: 'transparent',
    border: '0',
    cursor: 'pointer',
    height: 34,
    position: 'absolute',
    width: 34,
    ...datepickerReact.textInputToggle,
  },
  disabledToggle: {
    cursor: 'not-allowed',
  },
  screenReaderLabel: {
    top: -1,
  },
});
